import { combineEpics } from 'redux-observable';

import getSingleClientReportDetailsEpic$ from './single-client/getSingleClientReportDetailsEpic';
import getSingleClientReportEntriesEpic$ from './single-client/getSingleClientReportEntriesEpic';
import getSingleClientReportEntriesCountEpic$ from './single-client/getSingleClientReportEntriesCountEpic';
import exportSingleClientReportPdfEpic$ from './single-client/exportSingleClientReportPdfEpic';

import getScoringResultsReportEntriesEpic$ from './scoring-results/getScoringResultsReportEntriesEpic';
import getScoringResultsReportEntriesCount$ from './scoring-results/getScoringResultsReportEntriesCount';
import exportScoringResultsReportCsvEpic$ from './scoring-results/exportScoringResultsReportCsvEpic';

import getWatchListUpdateLogsEpic$ from './getWatchListUpdateLogsEpic';
import getWatchListUpdateLogsCountEpic$ from './getWatchListUpdateLogsCountEpic';
import getMultipleClientsReportEpic$ from './getMultipleClientsReportEpic';
import exportMultipleClientReportPdfEpic$ from './exportMultipleClientReportPdfEpic';
import exportMultipleClientReportHtmlEpic$ from './exportMultipleClientReportHtmlEpic';


export default combineEpics(
  getWatchListUpdateLogsEpic$,
  getWatchListUpdateLogsCountEpic$,
  getSingleClientReportEntriesEpic$,
  getSingleClientReportEntriesCountEpic$,
  getSingleClientReportDetailsEpic$,
  getMultipleClientsReportEpic$,
  exportSingleClientReportPdfEpic$,
  exportMultipleClientReportPdfEpic$,
  exportMultipleClientReportHtmlEpic$,
  exportScoringResultsReportCsvEpic$,
  getScoringResultsReportEntriesEpic$,
  getScoringResultsReportEntriesCount$
);


// WEBPACK FOOTER //
// ./src/features/reports/epics/index.js